var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCyborprotection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_915)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.653 9.78219H9.31638V8.52661C9.31638 6.21772 11.1937 4.34713 13.5045 4.34713C15.0231 4.34713 16.3437 5.1625 17.0738 6.38436L17.1013 6.36366C17.3459 6.70897 17.7384 6.95509 18.1955 6.95509C18.9463 6.95509 19.5565 6.34342 19.5565 5.59402C19.5565 5.4139 19.517 5.2357 19.4511 5.07581L19.4376 5.05027C19.3779 4.91109 19.2912 4.79069 19.191 4.68521C17.9508 2.84687 15.8794 1.625 13.5045 1.625C9.68676 1.625 6.60104 4.71748 6.60104 8.52659V9.78217H5.34739C4.59606 9.78217 3.98633 10.3924 3.98633 11.1432V22.0139C3.98633 22.7633 4.59606 23.3749 5.34739 23.3749H21.653C22.4038 23.3749 23.014 22.7633 23.014 22.0139V11.1432C23.014 10.3924 22.4038 9.78217 21.653 9.78217L21.653 9.78219ZM13.5045 19.2918C11.9971 19.2918 10.7824 18.0786 10.7824 16.5783C10.7824 15.0713 11.9971 13.8567 13.5045 13.8567C15.0028 13.8567 16.2175 15.0713 16.2175 16.5783C16.2175 18.0786 15.0028 19.2918 13.5045 19.2918Z",
    fill: "#212121",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyborprotection);
export default __webpack_public_path__ + "static/media/cyborprotection.946e1e77.svg";
export { ForwardRef as ReactComponent };